import axios from 'axios';
import { SET_STATES_OPTION } from './types';

export const setStatesOption = statesOption => ({
  type: SET_STATES_OPTION,
  payload: statesOption,
});

const getStatesOption = () => dispatch =>
  axios.get(`${APIENDPOINT}/states`).then(response => {
    dispatch(setStatesOption(response.data));
  });

export default getStatesOption;



// WEBPACK FOOTER //
// ./src/actions/stateOptions/setStatesOption.js